import myAxios from "@/plugins/axios";

const productService = {
    loadActiveProducts() {
        return myAxios.privateInstance
            .get(`/product`).then(resp => {
                return resp
            })
            .catch(error => {
                throw new Error(error);
            })
    },
}

export default productService